/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Table_Company_TypeInputs */

const en_clients_table_company_type = /** @type {(inputs: Clients_Table_Company_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company type`)
};

const pt_br2_clients_table_company_type = /** @type {(inputs: Clients_Table_Company_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de empresa`)
};

/**
* | output |
* | --- |
* | "Company type" |
*
* @param {Clients_Table_Company_TypeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_table_company_type = /** @type {((inputs?: Clients_Table_Company_TypeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Table_Company_TypeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_table_company_type(inputs)
	return pt_br2_clients_table_company_type(inputs)
});